import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CompanyMarginsActions } from '../actions/company-margins.actions';
import { CompanyMarginSave } from '../company-margins-state.model';

@Injectable({ providedIn: 'root' })
export class CompanyMarginsActionsFacade {
  private readonly _store = inject(Store);

  public loadCompanyMargins(companyId: number): void {
    this._store.dispatch(
      CompanyMarginsActions.loadCompanyMargins({ companyId }),
    );
  }

  public saveCompanyMargins(margins: CompanyMarginSave[]): void {
    this._store.dispatch(CompanyMarginsActions.saveCompanyMargins({ margins }));
  }

  public resetState(): void {
    this._store.dispatch(CompanyMarginsActions.resetState());
  }
}
